import styled from "styled-components";

export const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ShadowContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: flex-end;
  width: 200px;
  padding: 12px;

  font-size: 12px;

  /* .item {
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;

    &:first-child {
      margin-bottom: 20px;
    }
  } */
`;

export const ShadowSwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 29px;
`

export const ShadowTypeWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`

export const TypeButtonWrapper = styled.div`
  width: 90px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
`

export const TypeButton = styled.button`
  background: transparent;
  padding: 0;
  border: 0;
  font-size: 11px;
  color: ${props => props.active ? "#44ADF8": "#BABABA"};
  cursor: pointer;
`

export const ShadowBoxWrapper = styled.div`
  display: flex;
  gap: 10px;
`

export const AxisValuesBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 18px;

  div {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
  }
`

export const AxisInput = styled.input`
  width: 26px;
  border: 1px solid transparent;
  text-align: right;

  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &:focus,  
  &:hover {
    outline: none;
    border: 1px solid #c9c9c9;
    background-color: #ffffff;
  }
`

export const BlurWrapper = styled.div`
  display: flex;
  gap: 10px;

  .slider {
    max-width: 60px;
  }
`

export const BlurValuesBox = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;

  span {
    width: 18px;
    text-align: right;
  }
`